import type { PageContextResultPayload } from "./protocol";

const MAX_VISIBLE_TEXT = 6000;

/**
 * A read-only snapshot of what the visitor is currently looking at — never
 * an action, nothing on the page is touched. `widgetRoot` (the widget's own
 * host element) is hidden for the instant it takes to read `innerText` so
 * the widget's own UI text (button labels, etc.) doesn't leak into what's
 * meant to describe the *host page*.
 */
export function readPageContext(
  callId: string,
  widgetRoot: HTMLElement,
): PageContextResultPayload {
  const previousDisplay = widgetRoot.style.display;
  widgetRoot.style.display = "none";
  let visibleText: string;
  try {
    visibleText = (document.body.innerText || "").trim().slice(0, MAX_VISIBLE_TEXT);
  } finally {
    widgetRoot.style.display = previousDisplay;
  }

  return {
    call_id: callId,
    path: window.location.pathname,
    title: document.title,
    visible_text: visibleText,
  };
}
